export default __webpack_public_path__ + "static/image_les_suites@2x-b3929acf39dec3697022a075aeaed9b4.jpg";